import axios from "axios";
import { store } from "../store/Store";
const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
// console.log("base url", BASEURL);
const axiosInLife = axios.create({
  baseURL: BASEURL,
});
axiosInLife.interceptors.request.use((config) => {
  const auth = store.getState().lifedetail?.lifenum?.credentials;
  //console.log(auth);
  const token = auth?.accessToken;
  config.headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  return config;
});

export default axiosInLife;
